import { DynamicComponentProps } from "@/types/ModuleComponentProp.type"
import React from "react"
import styles from './InspectorComments.module.scss';
import { useTranslation } from 'react-i18next';
import { RootState } from "@/store/rootReducer";
import { useSelector } from "react-redux";
import { APP_CONFIG_KEY } from "@/types/AppConfig.type";



export const InspectorComments: React.FC<DynamicComponentProps> = ({ inspection, onValueChange }: DynamicComponentProps) => {
    const { t: translate } = useTranslation()
    const inspectorCommentLength = useSelector((state: RootState) => state.appConfig[APP_CONFIG_KEY.inspectorCommentLength] || 1000);

    return (
        <div className={styles.formContainer}>
            <div className={styles.inputGroup}>
                <label className={styles.lable} htmlFor="inspectorComment">{translate('Inspection Comment')}</label>
                <textarea id="inspectorComment" maxLength={inspectorCommentLength} name='inspectorComment' rows={4} value={inspection.inspectorComment || ''} onChange={onValueChange}></textarea>
            </div>
        </div>
    );
}